import { useKeycloak } from "@react-keycloak/web";

// Check if we're in print mode (for PDF generation)
const urlParams = new URLSearchParams(window.location.search);
const isPrintMode = urlParams.get('print') === 'true';
const hasInjectedToken = urlParams.get('token') !== null;

const PrivateRoute = ({ children }) => {
 const { keycloak } = useKeycloak();

 // Allow access in print mode with injected token
 if (isPrintMode && hasInjectedToken) {
   return children;
 }

 const isLoggedIn = keycloak.authenticated;

 return isLoggedIn ? children : null;
};

export default PrivateRoute;
